import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { Operation } from 'shell/view-models/operation';
import { DateTime } from 'luxon';
import { ValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface MunicipalityListProps {
  disabled?: boolean;
  value?: MunicipalityAnscVM | null;
  onChange: (municipality?: MunicipalityAnscVM | null) => void;
  error?: boolean;
  required?: boolean;
  label?: string;
  id?: string;
  fromDate?: DateTime | null;
}

export interface MunicipalityAnscVM {
  id?: string;
  description: string;
  descriptionAnpr?: string;
  province?: string;
  provinceCode?: string;
  startDate?: string;
  endDate?: string;
  locality?: string;
  istatCode?: string;
}

const MunicipalityListANSCComponent = ({
  disabled,
  onChange,
  required,
  value: selectedValue,
  error,
  label = 'Comune',
  id = 'municipality',
}: MunicipalityListProps): React.ReactElement => {
  const [municipalities] = useHttpFetch<
    HttpResponse<Array<ValueDomainType>>,
    Array<MunicipalityAnscVM>
  >(
    `${__ACT_API_URL__}/valori-dominio-atti?filters=idDominio:${DomainType.Municipality}:${Operation.EQUALS}`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: (response) => {
        return response.data.payload.map((el) => ({
          id: el?.key?.idValore,
          description: el.valore || '',
        }));
      },
    }
  );

  const data = (municipalities.data as Array<MunicipalityAnscVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`${id}-label`}>
        {required ? `${label} *` : `${label}`}
      </InputLabel>
      <PmiSelect
        labelId={`${id}-label`}
        id={id}
        name={id}
        value={selectedValue?.id}
        label={required ? `${label} *` : `${label}`}
        onChange={(event) => {
          onChange(data.find((service) => service.id === event.target.value));
        }}
        disabled={disabled}
        error={error}
      >
        {data.map((service) => (
          <MenuItem key={service.id} value={service.id}>
            {service.description}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

MunicipalityListANSCComponent.displayName = 'Municipality ANSC list component';

const MunicipalityListANSC = memo(MunicipalityListANSCComponent);

export default MunicipalityListANSC as typeof MunicipalityListANSCComponent;
